import React from 'react';
import ForgotPasswordLayout from './components/ForgotPasswordLayout';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import { useForgotPassword } from './hooks/useForgotPassword';

const ForgotPassword = () => {
  const {
    identifier,
    setIdentifier,
    loading,
    currentImageIndex,
    setCurrentImageIndex,
    errors,
    handleSubmit
  } = useForgotPassword();

  return (
    <ForgotPasswordLayout
      currentImageIndex={currentImageIndex}
      setCurrentImageIndex={setCurrentImageIndex}
    >
      <ForgotPasswordForm
        identifier={identifier}
        setIdentifier={setIdentifier}
        loading={loading}
        errors={errors}
        handleSubmit={handleSubmit}
      />
    </ForgotPasswordLayout>
  );
};

export default ForgotPassword;
